import { EventEmitter, SimpleChanges } from '@angular/core';
import * as i0 from "@angular/core";
import * as i1 from "../single-date-picker/single-date-picker.component";
/**
 * Date Range Component
 *
 * This component allows a user to select a date range by choosing start and end dates for the range. Start and
 * end dates for the date range are selected using instances of the SingleDatePickerComponent.
 *
 * For selectable date ranges populate either startYear and endYear or startDate or endDate.
 *
 * Input Properties:
 *  startYear: number that is the start of the range of years for which dates should be selectable, e.g. 2010
 *  endYear: number that is the end of the range of years for which dates should be selectable, e.g. 2021
 *  selectedDateRange: DateRange object that contains the start and end dates that are selected
 *
 * Output Properties:
 *  startDateChangeHandler: EventEmitter that emits the selected date range whenever the start date is changed
 *  endDateChangeHandler: EventEmitter that emits the selected date range whenever the end date is changed
 */
export class DateRangeComponent {
    constructor() {
        this.selectedDateRange = { startDate: null, endDate: null };
        this.startDateChangeHandler = new EventEmitter();
        this.endDateChangeHandler = new EventEmitter();
        // Initially selected date for the first date picker
        this.selectedStartDate = null;
        // Initially selected date for the second date picker
        this.selectedEndDate = null;
    }
    ngOnInit() {
        this.selectedStartDate = this.selectedDateRange.startDate;
        this.selectedEndDate = this.selectedDateRange.endDate;
        this.validateDateRange(this.selectedDateRange);
    }
    ngOnChanges(changes) {
        if (changes.selectedDateRange?.currentValue) {
            const newDateRange = changes.selectedDateRange.currentValue;
            this.selectedStartDate = newDateRange.startDate;
            this.selectedEndDate = newDateRange.endDate;
        }
        this.validateDateRange(this.selectedDateRange);
    }
    /**
     * Handles when the date in the first date picker is changed
     * @param newStartDate the newly selected date
     */
    startDateChanged(newStartDate) {
        this.selectedDateRange.startDate = newStartDate;
        this.startDateChangeHandler.emit(this.selectedDateRange);
    }
    /**
     * Handles when the date in the second date picker is changed
     * @param newEndDate the newly selected date
     */
    endDateChanged(newEndDate) {
        this.selectedDateRange.endDate = newEndDate;
        this.endDateChangeHandler.emit(this.selectedDateRange);
    }
    /**
     * Checks if a date range is valid (start date is before end date). If not, then the end date is cleared out.
     * @param dateRange: DateRange to validate
     */
    validateDateRange(dateRange) {
        if (dateRange.endDate instanceof Date && dateRange.startDate instanceof Date) {
            if (dateRange.endDate < dateRange.startDate) {
                this.selectedEndDate = null;
                this.endDateChanged(null);
            }
        }
    }
}
DateRangeComponent.ɵfac = function DateRangeComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || DateRangeComponent)(); };
DateRangeComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: DateRangeComponent, selectors: [["ycn-date-range"]], inputs: { startDate: "startDate", endDate: "endDate", startYear: "startYear", endYear: "endYear", selectedDateRange: "selectedDateRange" }, outputs: { startDateChangeHandler: "startDateChangeHandler", endDateChangeHandler: "endDateChangeHandler" }, standalone: false, features: [i0.ɵɵNgOnChangesFeature], decls: 2, vars: 14, consts: [[1, "form-group", "dropdown", 3, "dateChangeHandler", "startYear", "endYear", "startDate", "endDate", "isStartOfRange", "selectedDate", "selectedDateRange"], [1, "form-group", "dropdown", "menu-right", 3, "dateChangeHandler", "startYear", "endYear", "startDate", "endDate", "isStartOfRange", "selectedDate", "selectedDateRange"]], template: function DateRangeComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "ycn-single-date-picker", 0);
        i0.ɵɵlistener("dateChangeHandler", function DateRangeComponent_Template_ycn_single_date_picker_dateChangeHandler_0_listener($event) { return ctx.startDateChanged($event); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(1, "ycn-single-date-picker", 1);
        i0.ɵɵlistener("dateChangeHandler", function DateRangeComponent_Template_ycn_single_date_picker_dateChangeHandler_1_listener($event) { return ctx.endDateChanged($event); });
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵproperty("startYear", ctx.startYear)("endYear", ctx.endYear)("startDate", ctx.startDate)("endDate", ctx.endDate)("isStartOfRange", true)("selectedDate", ctx.selectedStartDate)("selectedDateRange", ctx.selectedDateRange);
        i0.ɵɵadvance();
        i0.ɵɵproperty("startYear", ctx.startYear)("endYear", ctx.endYear)("startDate", ctx.startDate)("endDate", ctx.endDate)("isStartOfRange", false)("selectedDate", ctx.selectedEndDate)("selectedDateRange", ctx.selectedDateRange);
    } }, dependencies: [i1.SingleDatePickerComponent], encapsulation: 2 });
